/**
 * ข้อมูลผู้ใช้ส่วนที่หน้า worklist ของเจ้าหน้าที่ใช้ร่วมกัน
 *
 * ทุก endpoint ของใบคำขอ (form-request-new-member, form-renew-member,
 * form-regis-appraiser, form-renew-appraiser, cpd-hours, exam-lists) join
 * `user.userInformation` (และ `userInformation.company`) มาให้อยู่แล้ว
 * ชนิดข้อมูลนี้จึงรวบรวมเฉพาะ field ที่ตารางและไฟล์ CSV ต้องใช้
 * แทนการประกาศซ้ำในแต่ละคอมโพเนนต์
 *
 * ทุก field เป็น optional เพราะผู้ยื่นคำขอที่กรอกข้อมูลไม่ครบจะไม่มีค่าส่งมา
 * เวลานำไปแสดงผลให้ fallback เป็น '-' เสมอ
 */
export interface UserInformationSummary {
  // ชื่อ-นามสกุล (มีได้หลายภาษา แล้วแต่ผู้ใช้กรอก)
  titleName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  firstNameThai?: string | null;
  lastNameThai?: string | null;
  firstNameEnglish?: string | null;
  lastNameEnglish?: string | null;

  /** เบอร์โทรติดต่อ */
  phoneNumber?: string | null;

  // บัตรสมาชิกสมาคม (VAT)
  vatId?: string | null;
  vatType?: string | null;
  vatExpired?: string | null;

  // บัตรผู้ประเมินหลัก (Valuer)
  valuerId?: string | null;
  valuerType?: string | null;
  valuerExpired?: string | null;

  // บริษัท/หน่วยงาน — อ่าน company.organizationName ก่อน แล้วค่อย fallback
  workplaceName?: string | null;
  organization?: string | null;
  company?: { organizationName?: string | null } | null;

  // ชั่วโมง CPD สะสม
  vatCpd?: string | null;
  tvaCpd?: string | null;
  otherCpd?: string | null;
  totalCpd?: string | null;
}

/** ชื่อ-นามสกุลของผู้ยื่นคำขอ ไล่จากภาษาไทยไปอังกฤษตามที่มีข้อมูล */
export function getFullNameFrom(
  info?: UserInformationSummary | null,
  fallback?: { firstName?: string | null; lastName?: string | null } | null
): string {
  const first = info?.firstName || info?.firstNameThai || info?.firstNameEnglish || fallback?.firstName || '';
  const last = info?.lastName || info?.lastNameThai || info?.lastNameEnglish || fallback?.lastName || '';
  return `${first} ${last}`.trim() || '-';
}

/** บริษัท/หน่วยงานของผู้ยื่นคำขอ */
export function getOrganizationFrom(info?: UserInformationSummary | null): string {
  return info?.company?.organizationName || info?.workplaceName || info?.organization || '-';
}

/** เบอร์โทรติดต่อของผู้ยื่นคำขอ */
export function getPhoneNumberFrom(info?: UserInformationSummary | null): string {
  const phone = info?.phoneNumber;
  return phone && String(phone).trim() !== '' ? String(phone) : '-';
}
